
    <fieldmagic-icon
      id='btnRebuildSearchDatabase'
      (click)='onClick()'
      icon='sync-alt'
      [spin]='isInProgress$ | async'
    >
      <span>Rebuild Search Database</span>
    </fieldmagic-icon>
  